import React, { FC } from 'react';
import { Text } from '@sitecore-jss/sitecore-jss-react';
import Icon from '../../../../@shared/icon';
import RoutableNotEditableLink from '../../../../@shared/routableNotEditableLink';

const DealerLocatorAttribute: FC<{ iconName: string; attribute: string; href: string; openInNewTab?: boolean }> = ({ iconName, attribute, href, openInNewTab=false }) => {
  return (
    <RoutableNotEditableLink target={openInNewTab ? '_blank' : ''} className={'dealer-locator-detail__contacts__attributes'} href={href}>
      <Icon iconName={iconName} color={'primary'} size={24} />
      <Text field={{ value: attribute }} tag="p" />
    </RoutableNotEditableLink>
  );
};

export default DealerLocatorAttribute;
